<template>
    <div>
        <div class="skeleton" v-if="skeleton"></div>
        <!-- <client-only> -->
        <div v-if="options && filter">
            <div v-show="!skeleton && options">
                <!-- <label class="for_desktop">{{filter.label}} </label> -->
                <div class="custom-dropdown">
                    <div class="current_active" @click="toggleFilterVisibilty">
                        <!-- <div class="drop_close" @click.stop="resetFilter()">
                            <span v-show="selectedOption" ><SvgHeaderSvg :type="'close'" /></span>
                        </div> -->
                        <div class="drop_name">
                          
                            <span class="">{{filter.label}} </span>
                            <!-- <span v-show="selectedOption" class="selected_label"> : ({{ selectedOption }})</span> -->
                        </div>
                        <div class="drop_arrow">
                            <SvgHeaderSvg v-if="showOptions" :type="'up'" />
                            <SvgHeaderSvg v-else :type="'down'" />
                        </div>
                    </div>
                    <ul class="" v-show="showOptions">
                        <div class="title_close ">
                            <div class="title">
                                <span>{{ name }}:&nbsp;</span>
                                <span class="active_label" 
                                    v-if="selectedOption">
                                    {{selectedOption}}
                                </span>
                                <span class="active_label for_desktop" 
                                    v-else>
                                    {{$formatPrice(options?.min)  +' - '+ $formatPrice( options?.max )}}
                                </span>
                            </div>
                            <div class="close for_desktop d-flex justify-content-center align-items-center" @click="showOptions = false">
                                <SvgHeaderSvg :type="'close'" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="my-3 col-md-12">
                                <div id="price-slider" ref="slider"></div>
                            </div>
                            <div class="col-md-6 col-6 ps-2">
                                <div class="input-group me-2">
                                    <input  
                                        class="form-control input_min" 
                                        :value="formatFromValue" 
                                        @focus="unsetNotation('from')"
                                        @focusout="handleInputBlur($event)"
                                        @blur="setNotation('from')"
                                        @keyup.enter="handleInputBlur($event)"
                                        @change="updateSlider('from', $event.target.value)"
                                        :min="options.min"
                                        :max="options.max"
                                        placeholder="" 
                                        name="price_from"
                                    />
                                    
                                </div>
                            </div>
                            <div class="col-md-6 col-6 text-end">
                                <div class="input-group ms-2">
                                    <input 
                                        class="form-control input_max" 
                                        :value="formatToValue" 
                                        @focus="unsetNotation('to')"
                                        @focusout="handleInputBlur($event)"
                                        @blur="setNotation('to')"
                                        @keyup.enter="handleInputBlur($event)"

                                        @change="updateSlider('to', $event.target.value)"
                                        :min="options.min"
                                        :max="options.max"
                                        placeholder="" 
                                        name="price_to" 
                                    />
                                </div>
                            </div>
                        </div>
                    </ul>
                    
                </div>

            </div>
        </div>
        <!-- </client-only> -->
    </div>
</template>


<script setup>
    import noUiSlider from 'nouislider'
    import { cyolistStore }  from '@/stores/cyolist/cyolist';
    const store = cyolistStore();
    const route = useRoute();

    const { $formatPrice } = useNuxtApp()

    const {name}  = defineProps(['name'])

    const slider = ref(true)

    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType 
    const sliderInitialized = ref(false)
    const showOptions = ref(false)
    const selectedOption = ref(null)
    const debounce = ref(null)
    const skeleton = ref(true)
    const notation = ref({
        from:true,
        to:true
    })


    const options = computed(() => {
        let option = store.getSettingFilterOptions( moduleSubType , name )
        return option
    })

    // const showOptions= computed(() => {
    //     return store.getSettingFilterVisibility(moduleSubType , name )
    // })

    const filter = computed(() => store.getSettingFilter(moduleSubType , name ))

    const formatFromValue = computed(() => {

        if ( ! filter.value.config.format || ! notation.value.from ) {

            return options.value.from
        }

        if( filter.value.name === 'price' ){

            return $formatPrice( options.value.from ) 
        }

        return filter.value.config.format.position == 'prepend'
                        ? filter.value.config.format.notation + options.value.from
                        : options.value.from + filter.value.config.format.notation
    })

    const formatToValue = computed(() => {

        if ( ! filter.value.config.format || ! notation.value.to ) {

            return options.value.to
        }
        
        if( filter.value.name === 'price' ){
            return $formatPrice( options.value.to ) 
        }

        return filter.value.config.format.position == 'prepend'
                    ? filter.value.config.format.notation + options.value.to
                    : options.value.to + filter.value.config.format.notation
    })

    watch(options, (newVal) => {
        if (newVal) {
            nextTick(() => {
                if (slider.value?.noUiSlider && newVal.max) {
                    slider.value.noUiSlider.set([parseFloat(newVal.from), parseFloat(newVal.to)])
                }else if( sliderEligibility() ){

                    initializeSlider()
                    skeleton.value = false
                }
            })
        }
    })


    // onUpdated(() => {
    //     if (sliderEligibility()) {
    //         initializeSlider()
    //         skeleton.value = false
    //     }
    // })

    onMounted( async () => {

        await nextTick();

        if (sliderEligibility()) {
            initializeSlider()
            skeleton.value = false
        }
        document.addEventListener('mousedown', handleClickOutside);
    })

    onBeforeUnmount(() => {
    // Destroy the slider if it has been initialized
        if (slider.value && sliderInitialized.value) {
            slider.value.noUiSlider.destroy();
            sliderInitialized.value = false;
        }
        // Remove event listener for clicks outside
    document.removeEventListener('mousedown', handleClickOutside)
    });

function handleClickOutside(event) {
    const dropdown = document.querySelector('.custom-dropdown');
    if (dropdown && !dropdown.contains(event.target)) {
        showOptions.value = false;
    }
}
    function sliderEligibility(){
        return !slider.value?.noUiSlider && options.value?.max && slider.value
    } 
    

    function unsetNotation(endpoint){
        notation.value[endpoint] = false
    }

    function setNotation(endpoint){
        notation.value[endpoint] = true
    }

    // check if slider is changed
    function hasChanged(){
        return options.value.from == options.value.min && options.value.to == options.value.max ? false : true
    }

    // show label of changed input values
    function updateSelectedOption() {

        if (hasChanged()) {

            return selectedOption.value = $formatPrice( options.value.from )  +' - '+ $formatPrice( options.value.to )
        }

        selectedOption.value = null
    }

    function handleInputBlur(event) {
        
        const object = { reset:false, type: moduleSubType , filter: filter.value , option : { value : options.value.from }  }
            store.toggleSettingFilter( object )
        event.target.blur();
    }

    function toggleFilterVisibilty( type ){
    
        showOptions.value = !showOptions.value
        // store.toggleSettingFilter({ type: moduleSubType , filter: filter.value, reset : false })
    }
    
    // update when input are changed
    function updateSlider(range, value){
      
        slider.value.noUiSlider.set( range == 'from' ?  [ value, null ] : [ null, value ] );
        updateSelectedOption()
    }
    
    // reset filters
    function resetFilter(){
        // reset from and to
        options.value.from   = parseFloat(options.value.min)
        options.value.to     = parseFloat(options.value.max)
        // update the slider
        // this.showOptions = false
        slider.value.noUiSlider.set( [options.value.min, options.value.max] );
        // hide slider with 0.5 sec, looks good
        setTimeout( ()=> {

            store.toggleSettingFilterVisibility({ type: moduleSubType , filter: filter.value, reset : true })

            const object = { reset:false, type: moduleSubType , filter: filter.value , option : { value : false }  }
            store.toggleSettingFilter(object )

            updateSelectedOption()
            // this.toggleFilter()
        }, 600 )
    }
    
    // emit in parent component
    function toggleFilter(value, reset = false) {

    }

    function initializeSlider(){

        if (!slider.value) {
            return
        }

        noUiSlider.create(  slider.value, {
            start: [ options.value.from , options.value.to ],
            connect: true,
            decimals: 0,
            step:1,
            range: {
                'min': parseFloat(options.value.min),
                'max': parseFloat(options.value.max),
            }
        });

        // on change of slider update input values
        slider.value.noUiSlider.on('update',  (values, handle) => {

            options.value.from   = parseFloat(values[0])
            options.value.to     = parseFloat(values[1])
        })

        // when user interaction is complete with slider, we will update input and emit to parent
        slider.value.noUiSlider.on('change',  (values, handle) => {

            updateSelectedOption()
            // this.toggleFilter()
            const object = { reset:false, type: moduleSubType , filter: filter.value , option : { value : false }  }

            store.toggleSettingFilter(object )

        })

        updateSelectedOption()

    }

      

</script>


<style scoped>
.drop_arrow .svg-head {
    height: 18px;
    width: 16px;
}
.skeleton {
    height: 42px;
    border-radius: 8px;
    background: #eaeaea;
    min-width: 85px;
}
input {
    border: 1px solid #eaeaea;
    /* font-size: 14px; */
    font-size: 16px;

    text-align: left;
    padding: 3px 5px;
    outline: none;
    width: 100%;
    border-radius: 4px;
}
label {
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
}
.selected_label{
    white-space: nowrap;
    width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.selected_label_mod {
    width: 140px;
}
.svg-head {
    height: 16px;
    width: 20px;
}
.drop_close .svg-head {
    height: 22px;
}
.title_close {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 15px 0 15px;


}

.close{
    cursor: pointer;
}

.title {
    font-size: 14px;
    text-transform: capitalize;
    font-weight: 700;
    color: #000;
    display: flex;
    align-items: center;
}

span.active_label {
    color: var(--green);
}
@media(max-width: 992px){
    .selected_label {
       width: 200px !important;
    }
   .selected_label_mod {
        width: 120px;
    }
}
@media(max-width: 1280px){
    .selected_label {
        width: 99px;
    }
    .selected_label_mod {
        width: 80px ;
    }
}
.current_active {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #c4c4c4;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 8px;
    height: 42px;
}

ul {
    padding: 0;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    background: #fff;
    z-index: 99;
    min-width: 250px;
}
.row{
    padding: 0 23px 13px 18px;
}
ul li{
    list-style: none;
    padding: 5px 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
ul li.active {
    background: rgba(204,204,204,0.36863);
}

ul li span{
    font-weight: 600;
    font-size: 14px;
    color: #6a6161;
}
.current_active span {
    font-weight: 400;
    font-size: 14px;
    text-transform: capitalize;
    font-weight: 400;
    color: #212529;
}

.custom-dropdown {
    position: relative;
    outline: none;
}
.drop_name {
    margin-right: 8px;
}

@media(max-width: 992px){
    
    /* .current_active {
        padding: 0 10px;
    } */

    span.active_filters {
        width: 140px;
    }
}

  @media(max-width: 767px){
    .title_close{
        padding: 0;
    }
    .row{
        padding: 0 8px;
    }
    .title span {
        text-transform: uppercase;
    }
    .input_max {
        margin-left: auto;
        margin-right: 15px;
    }
    input {
        min-width: 100px;
        min-height: 35px;
        max-width: 100px;
    } 
    .col-12, .col-6{
        padding: 0;
    }
    label {
        display: block;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        margin-bottom: 0;
    }
    .current_active{
        display: none !important;
    }
    ul{
        position: relative;
        border: 0;
        display: block !important;
        box-shadow: none;
        /* padding: 0 8px !important; */
    }

    ul li {
        flex-wrap: wrap;
        justify-content: center;
    }
    ul li{
        min-width: 65px;
        text-align: center;
        border: 1px solid #d6d6d6;
        border-radius: 4px;
        padding: 3%;
        margin: 10px 3% 0 0;
        min-height: 106px;
        text-align: center;
    }
    ul li.no_img {
        min-width: 90px;
        min-height: 32px;
        border-radius: 4px;
        padding: 7px 3px;
        display: revert;
    }

    ul li.no_img span {
        margin-top: 0;
    }
    ul li.active{
        background: #668b84;
    }
    ul li img {
        margin-right: 0 !important;
    }
    ul li span{
        display: block;
        font-size: 13px;
        font-weight: 600;
        width: 100%;
        white-space: normal;
        white-space: initial;
        text-transform: capitalize;
        margin-top: 10px;
    }
    ul li.active span{
        color: #fff;
    }
  }
</style>
